export enum SocketEmitters {
	onUnlockFile = "onUnlockFile",
}

export enum FileSources {
	EMAIL_ATTACHMENT = "email_attachment",
	CHAT_ATTACHMENT = "chat_attachment",
	FILE_BROWSER = "file_browser",
}

export type ProtectedFilePayload = {
	payload: any;
	fileSource: FileSources;
};
